export const MessageEventType = {
    START: 'start',
    STOP: 'stop',
};
export const MessageDeliveryStatus = {
    BLOCKED: 'blocked',
    OPTED_OUT: 'optedout',
    STARTED: 'started',
    STOPPED: 'stopped',
    UNREGISTERED: 'unregistered',
};
//# sourceMappingURL=constants.js.map